import { service } from "@server/client";
import type {
  StockWatchQuery,
  StockWatchQueryVariables,
} from "@server/gql/graphql";
import { stockWatchQuery } from "@server/queries/cart/stockWatch.query";

type StockWatch = Array<{ partNo: string; currentOnHand: number }>;

export const getStockWatch = async (variables: StockWatchQueryVariables) => {
  try {
    const response = await service<StockWatchQuery, StockWatchQueryVariables>({
      query: stockWatchQuery,
      variables,
    });

    return JSON.parse(atob(response.stockWatch)) as StockWatch;
  } catch (error: Error | unknown) {
    console.error("Error in getStockWatch", error);
    throw error;
  }
};
